import Aux from '../../hoc/Aux_';
import Sidebar from './Sidebar';
import SuperAdminSidebar from './SuperAdminSidebar';
import Header from './Header';
import Footer from './Footer';
import React, { Component } from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';
import Login from '../../containers/MainContent/Login/Login';
import InviteRegister from '../../containers/MainContent/invite/InviteRegister';
import AdminSignup from '../../containers/MainContent/adminSignup/AdminSignup';
import AdminSteps from '../../containers/MainContent/adminSignup/AdminSteps';
import Pages_blank from '../../containers/MainContent/Pages/Pages_blank';
import TrackedSharingReport from '../../containers/MainContent/invite/TrackedSharingReport';
import EmployeeSidebar from './EmployeeSidebar';
import ForgotPassword from '../../containers/MainContent/ForgotPassword/ForgotPassword';

class Layout extends Component {
  render() {
    const isLoggedIn = localStorage.getItem('loged_In') === 'true';
    const role = localStorage.getItem('role');
    const isSuperAdminChatPage = window.location.pathname?.slice(1) === 'chats';

    return (
      <Aux>
        {isLoggedIn ? (
          <main>
            <div id="wrapper">
              {this.props.sidebar ? (
                role === 'user' ? (
                  <Sidebar />
                ) : role === 'employeeWeb' ? (
                  <EmployeeSidebar />
                ) : (
                  <SuperAdminSidebar />
                )
              ) : null}
              <div className="content-page">
                <div
                  className={`content ${isSuperAdminChatPage ? 'content_without_pb' : ''}`}
                >
                  {this.props.header ? <Header /> : null}
                  {this.props.children}
                  <Route
                    exact
                    path="/tracked-hours-reports/sharing/:token"
                    render={(props) => (
                      <main>
                        <TrackedSharingReport {...props} />
                      </main>
                    )}
                  />
                </div>
                {this.props.footer ? <Footer /> : null}
              </div>
            </div>
          </main>
        ) : (
          <Switch>
            <Route
              path="/invite-register/:token"
              render={(props) => (
                <main>
                  <InviteRegister {...props} />
                </main>
              )}
            />
            <Route
              exact
              path="/tracked-hours-reports/sharing/:token"
              render={(props) => (
                <main>
                  <TrackedSharingReport {...props} />
                </main>
              )}
            />
            <Route
              exact
              path="/sign-up"
              render={(props) => (
                <main>
                  <AdminSignup {...props} />
                </main>
              )}
            />
            <Route
              exact
              path="/forgot-password"
              render={(props) => (
                <main>
                  <ForgotPassword {...props} />
                </main>
              )}
            />
            <Route
              exact
              path="/registered"
              render={(props) => (
                <main>
                  <AdminSteps {...props} />
                </main>
              )}
            />
            <Route
              render={() => (
                <main>
                  <Login />
                </main>
              )}
            />
          </Switch>
        )}
      </Aux>
    );
  }
}

export default withRouter(Layout);
